import { render, staticRenderFns } from "./CarrierDetails.vue?vue&type=template&id=3c4a380c&scoped=true&"
import script from "./CarrierDetails.vue?vue&type=script&lang=js&"
export * from "./CarrierDetails.vue?vue&type=script&lang=js&"
import style0 from "./CarrierDetails.vue?vue&type=style&index=0&id=3c4a380c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a380c",
  null
  
)

export default component.exports